import { useRef, useState } from 'react';
import {
	Button,
	Modal,
	Slider,
	Container,
	Row,
	Col,
	UploadButton,
	Stack,
} from 'components/ui/';
import AvatarEditor from 'react-avatar-editor';
import Dropzone from 'react-dropzone';
import useUploadAvatar from '../hooks/useUploadAvatar';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

const AvatarEdit = ({ internal, update }) => {
	const [show, setShow] = useState(false);
	const [t] = useTranslation();

	const handleClose = () => setShow(false);
	const handleShow = () => setShow(true);
	const uploadAvatar = useUploadAvatar(internal);

	const [image, setImage] = useState({ image: null });
	const [scale, setScale] = useState(2);
	const editor = useRef(null);

	const handleDrop = (dropped) => {
		setImage({ image: dropped[0] });
	};

	const onScale = (e) => {
		setScale(e.target.value);
	};

	const onClickSave = () => {
		if (editor.current) {
			// If you want the image resized to the canvas size (also a HTMLCanvasElement)
			const canvasScaled = editor.current.getImageScaledToCanvas();

			canvasScaled.toBlob(function (blob) {
				const formData = new FormData();
				formData.append('avatar', blob, 'avatar.png');
				uploadAvatar(formData, 'avatar.png');
				if (update) {
					update({});
				}
			});
		}
		handleClose();
	};

	const onChange = (files) => {
		setImage({ image: files[0] });
		handleShow();
	};

	return (
		<>
			<UploadButton
				label={t('impfschaeden.erfassen.profilbild_hochladen_und_bearbeiten')}
				onChange={onChange}
			/>

			<Modal show={show} onHide={handleClose}>
				<Modal.Header closeButton>
					<Modal.Title>
						{t('impfschaeden.erfassen.profilbild_bearbeiten')}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Container>
						<Row>
							<Col className='d-flex flex-column align-items-center'>
								<Dropzone
									onDrop={handleDrop}
									noClick
									noKeyboard
									// style={{ width: '250px', height: '250px' }}
								>
									{({ getRootProps, getInputProps }) => (
										<div {...getRootProps()}>
											<AvatarEditor
												ref={editor}
												// width={250}
												// height={250}
												image={image.image}
												// border={50}
												borderRadius={125}
												scale={scale}
												disableBoundaryChecks
											/>
											<input {...getInputProps()} />
										</div>
									)}
								</Dropzone>
								<Stack direction='horizontal' gap={5}>
									<div>
										{t('impfschaeden.erfassen.profilbild.bild_skalieren')}
									</div>
									<Slider
										aria-label='Scale'
										value={scale}
										onChange={onScale}
										min={1}
										max={15}
									/>
								</Stack>
								<Button onClick={onClickSave}>Save</Button>
							</Col>
						</Row>
					</Container>
				</Modal.Body>
			</Modal>
		</>
	);
};

AvatarEdit.propTypes = {
	internal: PropTypes.bool || PropTypes.undefined,
};

export { AvatarEdit };
